import { camelCase, mapKeys, type Dictionary } from "lodash";

export function convertFileToByteArray(file: File): Promise<number[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const array = new Uint8Array(reader.result as ArrayBuffer);
      resolve(Array.from(array));
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}

export type CamelCaseKeys<T> = {
  [K in keyof T as K extends string ? Uncapitalize<K> : K]: T[K];
};

export type PascalCaseKeys<T> = {
  [K in keyof T as K extends string ? Capitalize<K> : K]: T[K];
};

export function convertObjectKeysToCamelCase<T extends Dictionary<U>, U>(obj: PascalCaseKeys<T>): T {
  return mapKeys(obj, (_, key) => camelCase(key)) as T;
};